import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'semantic-ui-react'

const StandardButton = props => (
  <Button
    color={props.color}
    content={props.children ? props.children : props.content}
    disabled={props.disabled}
    fluid={props.fluid}
    icon={props.error ? 'warning sign' : props.icon}
    loading={props.pending}
    onClick={props.onClick ? props.onClick : null}
  />
)

StandardButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'red',
    'orange',
    'yellow',
    'olive',
    'green',
    'teal',
    'blue',
    'violet',
    'purple',
    'pink',
    'brown',
    'grey',
    'black',
    'facebook',
    'google plus',
    'instagram',
    'linkedin',
    'twitter',
    'vk',
    'youtube',
  ]),
  content: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fluid: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  pending: PropTypes.bool,
}

StandardButton.defaultProps = {
  children: null,
  color: 'black',
  content: '',
  disabled: false,
  error: false,
  fluid: false,
  pending: false,
}

export default StandardButton
